export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana10.38e954fa.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};